import APIKit from "../Allapis/Apikit/apikit";

export const generateInvoice = async (values) => {
  try {
    const url = `/invoice/pdf`;
    const res = await APIKit.post(url, values);
    return res.data;
  } catch (e) {
    console.log(e, "Error in generating invoice");
    return e.response ? e.response.data : e;
  }
};

